// ============================================
// PARALLAX CONFIGURATION - EDIT ALL VALUES HERE
// ============================================
// This file controls all parallax layer positions and movement speeds.
// Changes here automatically apply to the parallax component!

// ============================================
// PC SETTINGS (Desktop)
// ============================================

// --- DAY MODE PC ---
export const dayPC = {
  // Positions (where layers start, use % or px)
  skyPosition: '-25%',
  mountainPosition: '2%',
  forestPosition: '31%',
  cliffPosition: '36%',  // TBA - when cliff art is ready

  // Movement (parallax scroll speed - negative = moves up as you scroll)
  skyMovement: 0,
  mountainMovement: -110,
  forestMovement: -220,
  cliffMovement: -210,
};

// --- NIGHT MODE PC ---
export const nightPC = {
  // Positions
  skyPosition: '-24%',
  mountainPosition: '8%',
  forestPosition: '33%',
  cliffPosition: '41%',

  // Movement
  skyMovement: 0,
  mountainMovement: -70,
  forestMovement: -170,
  cliffMovement: -210,
};

// ============================================
// SMALL SCREEN SETTINGS (Tablets/Small laptops - 768px)
// ============================================

// --- DAY MODE SMALL ---
export const daySmall = {
  // Positions
  skyPosition: '-30%',
  mountainPosition: '10%',
  forestPosition: '33%',
  cliffPosition: '45%',

  // Movement
  skyMovement: 0,
  mountainMovement: -50,
  forestMovement: -80,
  cliffMovement: -110,
};

// --- NIGHT MODE SMALL ---
export const nightSmall = {
  // Positions
  skyPosition: '-30%',
  mountainPosition: '10%',
  forestPosition: '33%',
  cliffPosition: '45%',

  // Movement
  skyMovement: 0,
  mountainMovement: -50,
  forestMovement: -80,
  cliffMovement: -110,
};

// ============================================
// EXTRA SMALL SCREEN SETTINGS (Mobile - 480px)
// ============================================

// --- DAY MODE EXTRA SMALL ---
export const dayExtraSmall = {
  // Positions
  skyPosition: '-25%',
  mountainPosition: '3%',
  forestPosition: '31%',
  cliffPosition: '45%',

  // Movement
  skyMovement: 0,
  mountainMovement: -30,
  forestMovement: -60,
  cliffMovement: -130,
};

// --- NIGHT MODE EXTRA SMALL ---
export const nightExtraSmall = {
  // Positions
  skyPosition: '-24%',
  mountainPosition: '6%',
  forestPosition: '32%',
  cliffPosition: '40%',

  // Movement
  skyMovement: 0,
  mountainMovement: -80,
  forestMovement: -100,
  cliffMovement: -95,
};

// ============================================
// AUDIO FILES
// ============================================
export const audio = {
  dayAmbience: '/mountainday.mp3',
  nightAmbience: '/mountainnight.mp3',
};

// ============================================
// IMAGE FILES
// ============================================
export const dayImages = {
  sky: '/Icons/logo/daysky.webp',
  mountain: '/Icons/logo/daymountains2.webp',
  mountainShine: '/Icons/logo/daymountainshine2.webp',
  forest: '/Icons/logo/dayforest4.webp',
  forestShine: '/Icons/logo/dayforestshine11.webp',
  cliff: '/Icons/logo/cliffday2.webp',
  cliffShine: '/Icons/logo/cliffshine12.webp',
};

export const nightImages = {
  sky: '/Icons/logo/Skyback1.webp',
  mountain: '/Icons/logo/darkmountains.webp',
  mountainShine: '/Icons/logo/lightmountainsfix2.webp',
  forest: '/Icons/logo/forestdark3.webp',
  forestShine: '/Icons/logo/forestlight3.webp',
  cliff: '/Icons/logo/darkfront12.webp',
  cliffShine: '/Icons/logo/lightfront6.webp',
};

// ============================================
// HELPER: Get config based on theme and screen size
// ============================================
export const getConfig = (isDarkMode: boolean, screenSize: 'pc' | 'small' | 'extraSmall') => {
  if (isDarkMode) {
    switch (screenSize) {
      case 'pc': return nightPC;
      case 'small': return nightSmall;
      case 'extraSmall': return nightExtraSmall;
    }
  } else {
    switch (screenSize) {
      case 'pc': return dayPC;
      case 'small': return daySmall;
      case 'extraSmall': return dayExtraSmall;
    }
  }
};
